module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAKUlEQVRIx2MQ2WqFB/25KIYHnRNUw4MYRo0eNXrU6FGjR40eNXooGg0AAxkPxn4+ySwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/ml.png
// module id = 339
// module chunks = 0